import { render } from "./dinamicDialogTecnico.vue?vue&type=template&id=e53db0fe&scoped=true"
import script from "./dinamicDialogTecnico.vue?vue&type=script&lang=js"
export * from "./dinamicDialogTecnico.vue?vue&type=script&lang=js"

import "./dinamicDialogTecnico.vue?vue&type=style&index=0&id=e53db0fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e53db0fe"]])

export default __exports__